
/* eslint-disable vue/no-mutating-props */
// #727: who referred an Other-source client. `referral` is the orchestrator's
// state.referral, mutated in place like ReferralFields does.
import { COPY } from './copy'
import CrmSearch from './CrmSearch.vue'

export default {
    components: { CrmSearch },
    props: {
        referral: { type: Object, required: true },
        excludeIds: { type: Array, default: () => [] },
    },
    data () { return { COPY } },
    methods: {
        set (k, v) { this.$set(this.referral, k, v) },
        setType (t) {
            if (this.referral.referred_by_type === t) return
            this.set('referred_by_type', t)
        },
        onPick (record) {
            const id = record && (record.id || (record.survey && record.survey.id))
            const r = (record && record.survey) || record || {}
            this.set('referred_by_client_id', id || null)
            this.set('referred_by_client_name', `${r.first_name || ''} ${r.last_name || ''}`.trim())
        },
        unlink () {
            this.set('referred_by_client_id', null)
        },
    },
}
